<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>商城</el-breadcrumb-item>
      <el-breadcrumb-item>市场活动</el-breadcrumb-item>
    </el-breadcrumb>
    <WikiIndex :type="2"></WikiIndex>
  </div>
</template>

<script>
import WikiIndex from './index.vue'
export default {
  components: {
    WikiIndex,
  },
}
</script>